import fetch from "@lib/fetch";
import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";
import type { UserEventHistoryRequestStatus, RequestUserEventHistoryProps } from "./types";
import { isUserEventHistoryRequestStatus } from "./validators";

/**
 * Initiate a request for user events for display in the User Search "Event History" tab.
 * The query status is returned via websocket and a subsequent call retrieves the results.
 *
 * This is a POST -> Pusher websocket endpoint
 */
export const requestUserEventHistory = reactQueryPostWebsocketAdapter(
  cacheKey,
  async (signal, { userId, jobToken }: RequestUserEventHistoryProps): Promise<UserEventHistoryRequestStatus> => {
    return fetch(`/apps/user_event_history/${userId}`, "POST", { job_token: jobToken }, { signal });
  },
  isUserEventHistoryRequestStatus
);
